// permissions.utils.ts

import { NomObjectPermission, NomObjectPermissionRole } from './constants';

export const ROLE_PERMISSIONS_MAP: Readonly<
  Record<NomObjectPermissionRole, Readonly<NomObjectPermission[]>>
> = {
  [NomObjectPermissionRole.OWNER]: [
    NomObjectPermission.CAN_VIEW,
    NomObjectPermission.CAN_EDIT,
    NomObjectPermission.CAN_DELETE,
    NomObjectPermission.CAN_EXECUTE,
    NomObjectPermission.CAN_MANAGE,
    NomObjectPermission.CAN_ACTIVATE,
    NomObjectPermission.CAN_ARCHIVE,
    NomObjectPermission.CAN_AUDIT,
    NomObjectPermission.CAN_COMMIT,
    NomObjectPermission.CAN_CONFIG,
    NomObjectPermission.CAN_COPY,
    NomObjectPermission.CAN_CREATE,
    NomObjectPermission.CAN_DEACTIVATE,
    NomObjectPermission.CAN_EMAIL,
    NomObjectPermission.CAN_EXPORT,
    NomObjectPermission.CAN_FILTER,
    NomObjectPermission.CAN_LINK,
    NomObjectPermission.CAN_LOCK,
    NomObjectPermission.CAN_MOVE,
    NomObjectPermission.CAN_RESTART,
    NomObjectPermission.CAN_SCHEDULE,
    NomObjectPermission.CAN_UNARCHIVE,
    NomObjectPermission.CAN_UNLINK,
    NomObjectPermission.CAN_UNLOCK,
    NomObjectPermission.CAN_LIST,
    NomObjectPermission.CAN_CREATE_SEARCH_FEEDS,
    NomObjectPermission.CAN_CREATE_SHARING_FEEDS,
    NomObjectPermission.CAN_CREATE_COMBINED_FEEDS,
    NomObjectPermission.CAN_CREATE_PREMIUM_FEEDS,
    NomObjectPermission.CAN_CREATE_SOCIAL_FEEDS,
    NomObjectPermission.CAN_CREATE_CATALOG_FEEDS,
    NomObjectPermission.CAN_CREATE_DIMENSIONS,
  ],
  [NomObjectPermissionRole.VIEWER]: [NomObjectPermission.CAN_VIEW],
  [NomObjectPermissionRole.EDITOR]: [
    NomObjectPermission.CAN_VIEW,
    NomObjectPermission.CAN_EDIT,
    NomObjectPermission.CAN_DELETE,
  ],
  [NomObjectPermissionRole.CUSTOM]: [], // not used for forward mapping
  [NomObjectPermissionRole.ADMIN]: [
    NomObjectPermission.CAN_EDIT,
    NomObjectPermission.CAN_DELETE,
    NomObjectPermission.CAN_MANAGE,
  ],
};

export function normalizePermissions(perms: readonly number[]): number[] {
  const uniq = Array.from(new Set(perms));
  uniq.sort((a, b) => a - b);
  return uniq;
}

export function getRoleFromPermissionIds(
  permissionIds: ReadonlyArray<number | NomObjectPermission>,
): NomObjectPermissionRole {
  const normalized = normalizePermissions(permissionIds as number[]);
  for (const role of [
    NomObjectPermissionRole.OWNER,
    NomObjectPermissionRole.VIEWER,
    NomObjectPermissionRole.EDITOR,
  ]) {
    const rolePerms = normalizePermissions(ROLE_PERMISSIONS_MAP[role]);
    if (
      rolePerms.length === normalized.length &&
      rolePerms.every((v, i) => v === normalized[i])
    ) {
      return role;
    }
  }
  return NomObjectPermissionRole.CUSTOM;
}

export function getPermissionIdsFromRole(
  role: NomObjectPermissionRole,
): Readonly<NomObjectPermission[]> {
  return ROLE_PERMISSIONS_MAP[role] ?? [];
}
